var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sw-ProductCardDescription",style:({'--comp-line-to-display': _vm.lineToDisplay})},[_vm._v("\n  "+_vm._s(_vm.description)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }